import { render, staticRenderFns } from "./FieldsLayout.vue?vue&type=template&id=2612e216&scoped=true&"
import script from "./FieldsLayout.vue?vue&type=script&lang=js&"
export * from "./FieldsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2612e216",
  null
  
)

export default component.exports